import styles from './ModalOverlay.module.scss';

interface Props {
  children: JSX.Element;
}

export default function ModalOverlay({ children }: Props) {
  return <div className={styles['backdrop']}>{children}</div>;
}
